module.exports = __webpack_public_path__ + "static/cheese-pudding-a3342805da1cef1780bdaf373d5c9408.jpg";